import {
  FETCH_EVENT_BULK_INVOICES,
  FETCH_BULK_INVOICE,
  CREATE_BULK_INVOICE,
  UPDATE_BULK_INVOICE,
  SEND_BULK_INVOICE,
  VOID_BULK_INVOICE,
  REFRESH_BULK_INVOICE,
  CREATE_DELEGATION,
  CLEAR_CURRENT_INVOICE
} from './actions'

const initialState = {
  list: [],
  currentInvoice: null
}

export default function bulkInvoicesReducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_EVENT_BULK_INVOICES_SUCCESS':
      return {
        ...state,
        list: action.payload
      }

    case 'FETCH_BULK_INVOICE_SUCCESS':
      return {
        ...state,
        currentInvoice: action.payload
      }

    case 'CREATE_BULK_INVOICE_SUCCESS':
      return {
        ...state,
        list: [...state.list, action.payload],
        currentInvoice: action.payload
      }

    case 'UPDATE_BULK_INVOICE_SUCCESS':
    case 'SEND_BULK_INVOICE_SUCCESS':
    case 'VOID_BULK_INVOICE_SUCCESS':
    case 'REFRESH_BULK_INVOICE_SUCCESS':
      return {
        ...state,
        list: state.list.map(invoice =>
          invoice.id === action.payload.id ? action.payload : invoice
        ),
        currentInvoice: action.payload
      }

    case 'CREATE_DELEGATION_SUCCESS':
      return {
        ...state,
        currentInvoice: action.payload
      }

    case CLEAR_CURRENT_INVOICE:
      return {
        ...state,
        currentInvoice: null
      }

    default:
      return state
  }
}